import React, { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import AnnouncementModal from "./components/AnnouncementModal";
import { FaEdit, FaEye } from "react-icons/fa";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { useAnnouncementList } from "./hooks/useAnnouncement";
import { Spinner } from "reactstrap";
import AnnouncementPushNotificationModal from "./components/AnnouncementPushNotificationModal";

const ImageView = ({ mediaId }: any) => {
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  const ids = mediaId?.split(",").map((id: string) => id.trim()) || [];
  const selectedId = ids[0] || null;
  const imgSrc = selectedId
    ? `${BASE_URL}${selectedId}`
    : "https://via.placeholder.com/100?text=No+Image";

  return (
    <>
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner color="success" style={{ width: "2rem", height: "2rem" }} />
        </div>
      )}

      <img
        src={imgSrc}
        alt="avatar"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          cursor: "pointer",
          display: loading ? "none" : "inline-block",
        }}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
        onClick={() => !loading && selectedId && setShowPopup(true)}
      />

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowPopup(false)}
        >
          <img
            src={imgSrc}
            alt="Full View"
            style={{
              maxWidth: "90%",
              maxHeight: "80vh",
              borderRadius: "10px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
              cursor: "zoom-out",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

function Announcement() {
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [isOpenPushModal, setIsPushModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<"add" | "edit">("add");
  const [selectedRow, setSelectedRow] = useState<any>(null);
  
  const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    gradeMaster: null,
    designation: null,
    status: null,
    limit: 10,
    page: 1,
    search: null,
  
  });

  const { data: Announcement,isLoading:isLoading } = useAnnouncementList({
    params: {
      start:filtersState.page,
      length:filtersState.limit,
      search:filtersState.search
    },
    enabled: true,
  });

  const handleAddAnnouncements = () => {
    setModalMode("add");
    setSelectedRow(null);
    setIsModalOpen(true);
  };

  const handleEditAnnouncement = (row: any) => {
    setModalMode("edit");
    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const handleAnnouncementView = (row:any) => {
    setIsPushModalOpen(true);
    setSelectedRow(row)
  };


  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleExcel = async () => {
  try {
    const appToken = localStorage.getItem("Apptoken") || "";
    const start = filtersState?.page || "";
    const length = filtersState?.limit || "";
    const search = filtersState?.search || "";

    const params = new URLSearchParams();

    // Append only if value exists
    if (length) params.append("length", length);
    if (start) params.append("start", start);
  
    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getAnnouncementsListExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "AnnouncementsListData.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
};

  return (
    <div className="p-4">
      <PageHeader
        title="Announcements"
        buttons={[
          {
            label: "+ Add Announcements",
            onClick: handleAddAnnouncements,
            color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: handleExcel,
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Announcements List"
        data={Announcement?.data?.data || []}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={isLoading}
        columns={AnnouncementColumns(handleAnnouncementView, handleEditAnnouncement)}
        paginationTotalRows={Announcement?.data?.recordsTotal}
            onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
      />

      {/* Add/Edit Modal */}
      <RouteModal
        size="lg"
        toggle={() => setIsModalOpen(!isOpenModal)}
        isOpen={isOpenModal}
        title={modalMode === "add" ? "Add Announcement" : "Edit Announcement"}
        content={
          <AnnouncementModal
            selectedRow={selectedRow}
            mode={modalMode}
            setIsModalOpen={setIsModalOpen}
          />
        }
      />

      {/* Push Notification Modal */}
      <RouteModal
        size="md"
        toggle={() => setIsPushModalOpen(!isOpenPushModal)}
        isOpen={isOpenPushModal}
        title="Push Notification"
        content={
          <AnnouncementPushNotificationModal 
          selectedRow={selectedRow}
            mode={modalMode}
            setIsModalOpen={setIsPushModalOpen}/>
        }
      />
    </div>
  );
}

export default Announcement;

const AnnouncementColumns = (
  handleAnnouncementView: (row: any) => void,
  handleEditAnnouncement: (row: any) => void
) => [
  {
    name: "Announcement Media",
    cell: (row: any) => <ImageView mediaId={row.MediaIds} />,
    sortable: true,
    width: "200px",
  },
  {
    name: "Announcement Title",
    selector: (row: any) => row.AnnouncementTitle ?? "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Announcement Message",
    selector: (row: any) => row.AnnouncementMessage ?? "-",
    sortable: true,
    width: "240px",
  },
  {
    name: "Announcement Start Date",
    selector: (row: any) => row.AnnouncementStdate ?? "-",
    sortable: true,
    width: "240px",
  },
  {
    name: "Announcement End Date",
    selector: (row: any) => row.AnnouncementEdate ?? "-",
    sortable: true,
    width: "240px",
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleEditAnnouncement(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
        <button
          onClick={() => handleAnnouncementView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            marginLeft: "10px",
          }}
        >
          <FaEye style={{ fill: "#fff" }} /> View
        </button>
      </>
    ),
  },
];
